"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAgendaLabel = exports.agendaLabels = void 0;
const agendaLabels = exports.agendaLabels = {
  'Select product options & prepare draft presentation for senior review': 'Select and finalise the product options',
  'Approve draft presentation to send to client': 'Review and approve the selected product options',
  'Revise Options': 'Make changes to the product options',
  'Client options approval': 'Client approves the selected product options',
  'Prepare Quotation for Senior  Approval': 'Prepare the price quote for senior approval',
  'Source product & add to system': 'Find the product and add it to the system',
  'Send Quote': 'Send the price quote to the client',
  'Approve prepared Quotation to sent to client': 'Approve the price quote before sending it to the client',
  'Revise quote': 'Make changes to the price quote',
  'Confirm receipt of Quotation with client': 'Confirm that the client has received the price quote',
  "Confirm client's reaction on Quote": 'Check the client\'s response to the price quote',
  'Get Purchase Order': 'Receive the purchase order from the client',
  'Arrange Samples': 'Prepare the samples',
  'Arrange Sample Shipment': 'Arrange the shipment of samples',
  'Sample out for Delivery': 'Samples are on the way to the client',
  'Sample Delivered': 'Samples have reached the client',
  'Arrange Return Pick-up': 'Arrange pickup for the returned samples',
  'Return Decline Request': 'Request to reject the return',
  'Return Decline Accepted': 'The request to reject the return is approved',
  'Return Decline Rejected': 'The request to reject the return is not approved',
  'Sample out for Return': 'Samples are being sent back',
  'Sample Return Delivered': 'Returned samples have reached',
  'Sample Return Verified': 'Returned samples have been checked and confirmed'
};
const getAgendaLabel = agenda => {
  var _agendaLabels$agenda;
  return (_agendaLabels$agenda = agendaLabels[agenda]) !== null && _agendaLabels$agenda !== void 0 ? _agendaLabels$agenda : agenda;
};
exports.getAgendaLabel = getAgendaLabel;